import "./index.css";
import "./snap.css";
import "./soulmaze.css";
import "./mobile.css";
import "./polish.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-306" data-mp="2690vcrx3z117" />);
}